import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';
import { TryCatchStmt } from '@angular/compiler';

import { UtilesService } from './utiles.service';

import { CalendarioData } from '../Models/CalendarioData';
import { Calendario } from '../Models/Calendario';
@Injectable()
export class CalendarioService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService

  ) { }

  /**
   * Obtiene la informacion para generar el calendario
   * @param compania Codigo de la compañia
   */
  public ObtenerContadorCalendario(compania: string): Observable<Calendario[]> {

    try {

      let url = this._utiles.getURL("calendario/" + compania);

      return this._http.get(url).map((response: Response) => {
        return <Calendario[]>response.json();

      });

    } catch (error) {

      console.log(error);
    }

  }

}
